<template>
  <modal name="helpModal" ref="refHelpModal"
      :width="500"
      :height="230"
      :draggable="true"
      :resizable="false"
      :reset="true"
      :scrollable="true"
      :clickToClose="false"
      :adaptive="true">
    <div id="layer-popup">
        <div class="popup-header">
            <h2>지도통계서비스 도움말</h2>
            <button type="button" class="popup-close" @click="this.closeHelpBoard">
              <img src="../assets/web/images/icon_popup_close.png" alt="팝업닫기" title="팝업닫기">
            </button>
        </div>
        <div class="popup-cnt" style="font-weight: 500;">
          * 지도통계서비스 사용법 안내<br><br>
          1. 통계 항목은 3개까지 비교조회가 가능합니다.<br>
          2. 지도위의 정보는 2개연도까지만 표시됩니다.<br>
          3. 시도를 클릭하시면 시도별로 2개 이상의 연도 정보를 조회할 수 있습니다.
        </div>
    </div>
  </modal>
</template>

<script>
import { eventBus } from '@/event-bus'

export default {
  name: 'HelpBoard',
  components: {},
  data () {
    return {}
  },
  created () {
    eventBus.$on('showHelpBoard', () => {
      this.$modal.show('helpModal')
    })
  },

  mounted () {
  },

  beforeDestroy () {
    this.closeHelpBoard()
  },

  methods: {
    closeHelpBoard  () {
      this.$modal.hide('helpModal')
    }
  }
}
</script>

<style scoped>
.vm--container {
  width: 0px;
  height: 0px;
  z-index: 1000;
}

</style>

<style>
.vm--overlay[data-modal="helpModal"] {
  width: 0px;
  height: 0px;
  background: transparent;
}
</style>
